<template>

    <div class="toggle-wrapper" :class="{ multi : noshrink }">
        <span class="caption ft-xbld">{{ caption }}</span>
        <div class="toggle-outer">
            <div class="bg"></div>
            <div class="toggler" :style="togglerStyle"></div>
            <div class="items ft-bld">
                <span v-for="item, key in items" :key="item" :style="itemStyle" :class="{ active : currentItem == key}" @click.prevent="toggleItem(key)">{{ item }}</span>
            </div>
        </div>
    </div>

</template>

<script>

    export default {

        name: 'ToggleWrapper',

        props: {
            value: {
                type: Number,
                default: 0
            },
            caption: String,
            items: Array,
            noshrink: {
                type: Boolean,
                default: false
            },
            tempDelay: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                currentItem: 0
            }
        },

        mounted() {
            this.currentItem = this.value
        },

        computed: {
            itemStyle() {
                if (this.noshrink)
                    return { width: 50 + '%'}
                else
                    return { width: Math.round(100 / this.items.length) + '%'}
            },
            togglerStyle() {
                if (this.noshrink && this.currentItem < 2)
                    return { width: 'calc(' + 50 + '% - 6px)', transform: 'translate(calc(' + (100 * this.currentItem) + '% + ' + (6 * this.currentItem) + 'px), 0)' }
                if (this.noshrink && this.currentItem > 1)
                    return { width: 'calc(' + 50 + '% - 6px)', transform: 'translate(calc(' + (100 * (this.currentItem - 2)) + '% + ' + (6 * (this.currentItem - 2)) + 'px),calc(100% + 6px))' }
                if (!this.noshrink)
                    return { width: 'calc(' + parseFloat((100 / this.items.length).toFixed(1)) + '% - 6px)', transform: 'translateX(calc(' + (100 * this.currentItem) + '% + ' + (6 * this.currentItem) + 'px))' }
            }
        },

        methods: {

            toggleItem(key) {
                this.currentItem = key
                this.$emit("input", key)
                if (this.tempDelay)
                    this.$emit('tempDisable')
            }
        }
    }
</script>